export const FALLBACK_SKILLS: string[] = [
  'Jewellery Designer',
  'Graphic Designer',
  'Merchandiser',
  'CAD Designer',
  'Product Development',
  'Production Manager',
  'Data Entry Operator',
  'GATI Job',
  'HR Recruiter',
  'HR Generalist',
  'Retail Sales Executive',
  'Showroom Manager',
  'Floor Manager',
  'Gemologist',
  'Diamond Grader',
  'B2B International Sales',
  'B2B Domestic Sales',
  'CRM Executive',
  'Quality Control',
  'Lab Technician',
  'Instructor',
  'Business Development Manager',
  'Customer Support',
  'Digital Marketing',
  'Jewellery Photographer',
  'Software Developer',
  'Cashier',
  'Back office executive',
  'Purchase Executive',
  'Inventory Executive',
  'Inventory Manager',
  'Senior Retail Sales Executive',
  'Production Head',
  'Factory Head',
  'Factory Manager',
  'Inside Sales',
  'Accountant',
  'Financial Executive',
  'Karigars',
  // Core Industry
  'Product knowledge (diamonds, gemstones, metals)',
  'Luxury customer experience',
  'Visual merchandising',
  'Inventory management',
  'CRM & clienteling',
  'Sales closing techniques',
  'Brand storytelling',
  'Attention to detail',
  // Jewellery
  'Diamond grading (4Cs)',
  'Gemstone identification',
  'Metal purity & hallmarking',
  'Rhino',
  'Custom jewellery consultation',
  'Repair & after-sales knowledge',
  'Matrix',
  'Consultative Sales',
  // Luxury Retail
  'Clienteling & VIP management',
  'Upselling & cross-selling',
  'Omnichannel retail',
  'Store operations',
  'Personal shopper',
  'HNI client handling',
  'Complaint resolution',
  // D2C
  'Performance marketing (Meta, Google Ads)',
  'Conversion Rate Optimization (CRO)',
  'Shopify/WooCommerce management',
  'Customer lifecycle marketing',
  'Analytics (GA4, Mixpanel)',
  'Marketplace management',
  'UX/UI understanding',
  // Marketing
  'Luxury brand positioning',
  'Influencer collaborations',
  'Social media strategy',
  'Content creation',
  'SEO for eCommerce',
  'Campaign planning',
  'Copywriting',
  // Tools & Platforms
  'Salesforce',
  'Zoho',
  'HubSpot',
  'POS systems',
  'Shopify',
  'Magento',
  'Meta Ads Manager',
  'Google Ads',
  'Excel',
  'Google Sheets',
  'Adobe Suite',
];

export const FALLBACK_CATEGORIES: string[] = [
  'Lab Grown Diamond',
  'Natural Diamond',
  'Gemstone',
  'Diamond Grading',
  'Jewellery Retail',
  'Jewellery Manufacturing',
  'Bags',
  'Watches',
  'Cosmetics',
  'Footwear',
  'Sanitary Wares',
  'Bridal Wear',
  'Clothing',
  'Bathware',
];

export const FALLBACK_INDUSTRIES: string[] = [
  'Jewellery',
  'Luxury Retail',
  'Precious Metals',
  'Mining',
  'Gemstone',
  'D2C Brands',
];
